import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=97945440&"
import script from "./ContextMenuItem.vue?vue&type=script&lang=ts&"
export * from "./ContextMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports